import { writeMdxAttribute } from "../extensions/mintlify/icon-html"
import { normalizeTooltipAttributes } from "../extensions/mintlify/tooltip-html"

interface TurndownLike {
	addRule: (
		key: string,
		rule: {
			filter: (node: Node) => boolean
			replacement: (content: string, node: Node) => string
		},
	) => void
}

const hasClass = (node: Node, name: string): boolean =>
	node.nodeName === "SPAN" &&
	((node as HTMLElement).getAttribute("class") ?? "")
		.split(/\s+/)
		.includes(name)

const isTooltip = (node: Node): boolean =>
	node.nodeName === "SPAN" &&
	(node as HTMLElement).getAttribute("data-type") === "tooltip"

/** Writes a tooltip as Mintlify's tag, in the order its own docs use. */
export function tooltipMdx(element: HTMLElement, content: string): string {
	const attributes = normalizeTooltipAttributes({
		tip: element.getAttribute("data-tip"),
		headline: element.getAttribute("data-headline"),
		cta: element.getAttribute("data-cta"),
		href: element.getAttribute("data-href"),
	})
	const parts = [
		attributes.headline
			? writeMdxAttribute("headline", attributes.headline)
			: "",
		writeMdxAttribute("tip", attributes.tip),
		attributes.cta ? writeMdxAttribute("cta", attributes.cta) : "",
		attributes.href ? writeMdxAttribute("href", attributes.href) : "",
	].filter(Boolean)
	return `<Tooltip ${parts.join(" ")}>${content.trim()}</Tooltip>`
}

export function addTooltipMarkdownRules(turndown: TurndownLike): void {
	// The popup repeats the attributes as text; the tag already carries them.
	turndown.addRule("mintlifyTooltipPopup", {
		filter: (node) => hasClass(node, "pl-tooltip-content"),
		replacement: () => "",
	})
	turndown.addRule("mintlifyTooltip", {
		filter: isTooltip,
		replacement: (content, node) => tooltipMdx(node as HTMLElement, content),
	})
}
